import React from "react";

import { getToken } from "../../services/session";

const NOT_FOUND_IMG = `${process.env.PUBLIC_URL || ""}/no_picture_male.png`;

function withMediaAuth(src) {
  if (!src || typeof src !== "string") {
    return src;
  }
  if (src.includes("sig=")) {
    return src;
  }
  if (src.indexOf("aria-api.saawis.com") === -1) {
    return src;
  }
  const token = getToken();
  if (!token) {
    return src;
  }
  const sep = src.includes("?") ? "&" : "?";
  return `${src}${sep}access_token=${encodeURIComponent(token)}`;
}

const Img = ({ src, border }) => {
  const resolvedSrc = withMediaAuth(src) || NOT_FOUND_IMG;

  const handleImage = (e) => {
    e.target.onerror = null;
    e.target.src = NOT_FOUND_IMG;
  };

  const imgEl = (
    <img onError={handleImage} src={resolvedSrc} alt="" loading="lazy" />
  );

  if (!border) {
    return imgEl;
  }

  return (
    <span className="img-with-border">
      {imgEl}
      <i className="img-border"></i>
    </span>
  );
};

export default Img;
